<template>
  <div id="login-controller">
    <Login v-if="!global.loggedIn" />
    <Dashboard v-else-if="['admin', 'sewist'].includes(global.accountType)" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import Login from "@/components/screens/Login";
import Dashboard from "@/components/screens/Dashboard";
export default {
  name: "LoginController",
  components: { Login, Dashboard },
  computed: {
    ...mapState(["global"])
  },
  props: {
    sewistOverride: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {};
  },
  mounted() {
    if (this.$route && this.$route.params && this.$route.params.vars) {
      this.handleVars(this.$route.params.vars);
    }
    if (this.sewistOverride) {
      this.loginSewist();
    }
  },
  methods: {
    loginSewist() {
      //this method exists in two places. if further complexity is added. refactor to controller structure
      const url = process.env.VUE_APP_BASE_URL + "/api/sewistData";
      axios({
        method: "get",
        url: url
      }).then(res => {
        if (res && res.data) {
          this.setUserDataAndType({
            accountType: "sewist",
            userData: { sortedRequests: res.data.sortedRequests }
          });
          this.setTotalStats(res.data.totalStats);
        }
      });
    },
    handleVars(vars) {
      if (vars.indexOf("s=") > -1) {
        const success = vars.substr(vars.indexOf("s=") + 2, 4) == "true";
        if (success) {
          this.$swal({
            title: "Thank you!",
            text: "A confirmation for your request has been emailed to you.",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Okay"
          }).then(result => {
            window.location = "https://thesewingarmy.com";
          });
        } else {
          this.$swal({
            title: "Error!",
            text:
              "Looks like something went wrong. Contact the admin or check your email to see if the action was successful!",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Okay"
          }).then(result => {
            window.location = "https://thesewingarmy.com";
          });
        }
        this.$router.push("/");
      }
    },
    ...mapActions(["setUserDataAndType", "setTotalStats"])
  }
};
</script>

<style lang="scss" scoped>
#login-controller {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to right, rgb(32, 53, 109), rgb(216, 60, 180));
}
</style>